import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import { BCMSStateManagerCRUD, BCMSRecord, useGlobalController } from "bcms-react";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersToSelected
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from and to dropdowns
 * having values selected for the transfers group.
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersToSelected(props) {
    // Initalize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);

    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // Then updating the from and to properties of the transfer to the selected accounts
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], Account.initByID(0))
        .update([ "transfer", "to" ], Account.initByID(1))
        .submit();

    // Return the TransfersPage passing the data variable
    return <TransfersPage data={ data } />
}